'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.88109e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -5.72404e-05 6.66667 8.88109e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333H28V6.66667H0V13.3333Z",
          fill: "#0C47B7"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0L0 20Z",
          fill: "#E53B35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.61737 5.28208C5.6449 4.56617 6.23327 3.99999 6.94971 3.99999H13.0503C13.7667 3.99999 14.3551 4.56617 14.3827 5.28208L14.6419 12.0226C14.6576 12.4294 14.4864 12.8212 14.1773 13.0861L11.3016 15.551C10.5526 16.193 9.44741 16.193 8.69843 15.551L5.82274 13.0861C5.51359 12.8212 5.34247 12.4294 5.35812 12.0226L5.61737 5.28208Z",
          fill: "#F73744"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.94971 2.66666H13.0503C14.4832 2.66666 15.6599 3.79902 15.715 5.23084L15.9743 11.9713C16.0056 12.7851 15.6633 13.5685 15.045 14.0985L12.1693 16.5634C10.921 17.6333 9.079 17.6333 7.8307 16.5634L4.95502 14.0985C4.33672 13.5685 3.99447 12.7851 4.02577 11.9713L4.28502 5.23084C4.34009 3.79902 5.51683 2.66666 6.94971 2.66666ZM6.94971 3.99999C6.23327 3.99999 5.6449 4.56617 5.61737 5.28208L5.35812 12.0226C5.34247 12.4294 5.51359 12.8212 5.82274 13.0861L8.69843 15.551C9.44741 16.193 10.5526 16.193 11.3016 15.551L14.1773 13.0861C14.4864 12.8212 14.6576 12.4294 14.6419 12.0226L14.3827 5.28208C14.3551 4.56617 13.7667 3.99999 13.0503 3.99999H6.94971Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33356 11C9.33356 10.8159 9.18432 10.6666 9.00023 10.6666H7.66689C7.4828 10.6666 7.33356 10.5174 7.33356 10.3333V9.66664C7.33356 9.48255 7.4828 9.33331 7.66689 9.33331H9.00023C9.18432 9.33331 9.33356 9.18407 9.33356 8.99997V8.33331C9.33356 8.14921 9.18432 7.99997 9.00023 7.99997H8.33356C8.14946 7.99997 8.00023 7.85074 8.00023 7.66664V6.99997C8.00023 6.81588 8.14946 6.66664 8.33356 6.66664H9.00023C9.18432 6.66664 9.33356 6.5174 9.33356 6.33331V5.66664C9.33356 5.48255 9.4828 5.33331 9.66689 5.33331H10.3336C10.5177 5.33331 10.6669 5.48255 10.6669 5.66664V6.33331C10.6669 6.5174 10.8161 6.66664 11.0002 6.66664H11.6669C11.851 6.66664 12.0002 6.81588 12.0002 6.99997V7.66664C12.0002 7.85074 11.851 7.99997 11.6669 7.99997H11.0002C10.8161 7.99997 10.6669 8.14921 10.6669 8.33331V8.99997C10.6669 9.18407 10.8161 9.33331 11.0002 9.33331H12.3336C12.5177 9.33331 12.6669 9.48255 12.6669 9.66664V10.3333C12.6669 10.5174 12.5177 10.6666 12.3336 10.6666H11.0002C10.8161 10.6666 10.6669 10.8159 10.6669 11V13C10.6669 13.1841 10.5177 13.3333 10.3336 13.3333H9.66689C9.4828 13.3333 9.33356 13.1841 9.33356 13V11Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2034 13.4254C10.9887 12.9766 10.5305 12.6667 9.99985 12.6667C9.46918 12.6667 9.01092 12.9767 8.7963 13.4255C7.17537 13.6809 6.00001 14.4385 6.00001 15.3333C6.00001 16.4379 7.79087 17.3333 10 17.3333C12.2091 17.3333 14 16.4379 14 15.3333C14 14.4384 12.8245 13.6808 11.2034 13.4254Z",
          fill: "#1251A1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28 0V6.66826H27.5V0.5H0.5L0.5 6.66826H0L8.88109e-06 0H28Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagSkAsset = forwardRef(FlagSkAsset);

export { VpFlagSkAsset as default };
